module.exports = __webpack_public_path__ + "img/icon5.d3478398.png";